<header class="app-header" [class.app-header--compact]="compact()">
  <div class="app-header__inner">
    <button
      type="button"
      class="app-header__menu"
      [attr.aria-label]="'header.openMenu' | translate"
      aria-controls="mobile-navigation-drawer"
      [attr.aria-expanded]="mobileNavigation.isOpen()"
      (click)="mobileNavigation.toggle()"
    >
      <span class="material-symbols-outlined app-header__menu-icon" aria-hidden="true">menu</span>
    </button>

    <a routerLink="/" class="app-header__brand" [attr.aria-label]="'header.brandHome' | translate: { brand: brand.name }">
      <img class="app-header__brand-logo" [src]="brand.logoOnDark" alt="" />
    </a>

    <div class="app-header__actions">
      @if (session.currentUser(); as user) {
        <div class="app-header__balance">
          <span class="app-header__balance-label">{{ 'header.balance' | translate }}</span>
          <button type="button" class="balance-toggle" (click)="balanceVisibility.toggle()"
                  [title]="(balanceVisibility.hidden() ? 'header.showBalance' : 'header.hideBalance') | translate">
            <strong class="app-header__balance-value" [class.is-masked]="balanceVisibility.hidden()"
                    [attr.aria-hidden]="balanceVisibility.hidden() ? 'true' : null">
              @if (balanceVisibility.hidden()) {
                <span class="balance-mask-stars">****</span>,<span class="balance-mask-stars">**</span>
              } @else {
                {{ user.Credit | currency:'EUR':'symbol':'1.2-2':session.currentLanguage() }}
              }
            </strong>
            <span class="material-symbols-outlined balance-toggle__icon" aria-hidden="true">{{ balanceVisibility.hidden() ? 'visibility_off' : 'visibility' }}</span>
            <span class="balance-toggle__label">{{ (balanceVisibility.hidden() ? 'header.showBalance' : 'header.hideBalance') | translate }}</span>
          </button>
        </div>

        <div class="app-header__profile">
          <button
            #profileTrigger
            type="button"
            class="app-header__utility-button app-header__profile-button"
            [attr.aria-label]="'header.openProfile' | translate"
            aria-controls="account-profile-popup"
            [attr.aria-expanded]="headerMenu.isProfileOpen()"
            [title]="user.Username"
            (click)="toggleProfileMenu()"
          >
            <span class="material-symbols-outlined" aria-hidden="true">person</span>
          </button>

          @if (headerMenu.isProfileOpen()) {
            <div id="account-profile-popup" class="app-header__profile-menu" role="group" [attr.aria-label]="'account.menuLabel' | translate">
              <button
                type="button"
                class="app-header__profile-menu-item"
                (click)="openChangePassword()"
              >
                <span class="material-symbols-outlined app-header__profile-menu-icon" aria-hidden="true">lock_reset</span>
                <span>{{ 'account.changePassword.action' | translate }}</span>
              </button>

              <button
                type="button"
                class="app-header__profile-menu-item"
                (click)="openChangeUsername()"
              >
                <span class="material-symbols-outlined app-header__profile-menu-icon" aria-hidden="true">badge</span>
                <span>{{ 'account.changeUsername.action' | translate }}</span>
              </button>

              <button
                type="button"
                class="app-header__profile-menu-item app-header__profile-menu-item--danger"
                (click)="logout()"
              >
                <span class="material-symbols-outlined app-header__profile-menu-icon" aria-hidden="true">logout</span>
                <span>{{ 'account.logout.action' | translate }}</span>
              </button>
            </div>
          }
        </div>
      }

      @if (!session.currentUser()) {
        <button type="button" class="app-header__auth-button app-header__auth-button--login" (click)="authDialog.openLogin()">
          {{ 'auth.login' | translate }}
        </button>

        <button type="button" class="app-header__auth-button app-header__auth-button--signup" (click)="authDialog.openSignup()">
          {{ 'auth.signup' | translate }}
        </button>
      }

      <app-language-switcher></app-language-switcher>
    </div>
  </div>
</header>
